module.exports = {
    "index": {
        "login": "會員排行榜",
        "regist": "給新用戶的禮物",
        "user": "新團隊",
        "jiang": "會員",
        "set": "備註",
        "lingqyu": "未輸入備註,請設定",
        "liji": "未輸入IFSC,請設定",
        "list": {
            "0": "存入時間",
            "1": "金融卡資訊",
            "2": "註:比特幣錢包、USDT錢包充值。贈送充值本金10%+20美金手續費",
            "3": "很遺憾沒有搶到,請繼續搶購",
            "4": "美元",
            "5": "首日訂單量已達20,無法繼續下單",
            "6": "立即提交"
        },
        "xuanchaun": {
            "xiazai": {
                "0": "銀行帳戶",
                "1": "取消搶單"
            },
            "tianjia": {
                "0": "地址",
                "1": "未輸入地址,請設定"
            },
            "tiqu": {
                "0": "請輸入",
                "1": "帳戶餘額不足200,請充值後搶單"
            }
        },
        "guanyu": {
            "title1": "請檢查帳戶餘額",
            "text1": "帳戶可用餘額不足",
            "title2": "該訂單已處理,請重新整理頁面",
            "text2": "參數錯誤,請確認訂單編號"
        },
        "title_content": {
            "0": "訂單號碼不存在",
            "1": "搶單失敗,此分類下價格區間庫存不足",
            "2": "搶單失敗!請稍後再試"
        },
        "content": {
            "0": "搶單成功",
            "1": "的訂單,餘額不足,請重新搶單",
            "2": "搶到"
        },
        "dugengduo": "會員等級餘額不足",
        "darkgrey": {
            "1": {
                "title": "搶單已終止",
                "text": "簽到時間"
            },
            "2": {
                "title": "獲得紅包",
                "text": "前往充值"
            },
            "3": {
                "title": "再看看",
                "text": "需要帳戶餘額大於200才可以解鎖"
            },
            "4": {
                "title": "下一步",
                "text": "驗證碼"
            },
            "5": {
                "title": "請輸入驗證碼",
                "text": "圖形驗證碼驗證失敗,請重新輸入"
            },
            "6": {
                "title": "請求成功",
                "text": "手機號碼格式不正確"
            }
        },
        "into": {
            "yibiaoban": "帳號不存在",
            "nihao": "用戶不存在",
            "yue": "使用者已停用",
            "shebeigong": "此帳號已在別處登入狀態",
            "riqi": "密碼連續錯誤次數太多，請",
            "gaishu": "分鐘後再試",
            "kaicaizong": "密碼錯誤",
            "xiaoshili": "登入成功",
            "rili": "驗證碼不存在",
            "zhouli": "驗證碼錯誤",
            "yeli": "驗證碼失效",
            "tuilian": "邀請碼不存在",
            "hezuo": "該推薦用戶已被停用",
            "fukuanxin": "錯誤請求",
            "tianjiadi": "請先登入",
            "gengxin": "該帳戶已停用",
            "yibiaoti": "該帳戶交易功能已被凍結",
            "yaoqing": "該帳戶存在未完成訂單,無法繼續搶單",
            "yaoqingren": "餘額低於",
            "shijian": "無法繼續交易",
            "choujiangci": "會員等級交易次數不足",
            "choujianggai": "利息寶",
            "tuijianren": "未到期提前提取,未收益,手續費為",
            "xiejie": "該產品最低起投金額",
            "jiriqi": "該產品最高可投金額",
            "dianjifu": "數據異常",
            "tishi": {
                "1": "可用餘額不足",
                "2": "操作成功",
                "3": "操作失敗!請檢閱帳號餘額"
            },
            "chongzhijin": "起投",
            "chongzhigai": "操作",
            "nindeyu": "利息寶餘額轉入",
            "mianchong": "重複操作",
            "mianchongci": "利息寶餘額轉出",
            "chongzhili": {
                "title": "參數錯誤",
                "jine": "禁止在",
                "shijian": "以外的時間段執行目前操作",
                "zhauntai": "充值不能小於"
            },
            "yijiangli": "充值不能大於",
            "yiqizhuan": "圖片格式錯誤",
            "jianglili": "提交失敗,請稍後再試",
            "shezhi": "微信支付",
            "mimashe": "支付寶支付",
            "dangqianmishu": "微信提現",
            "xinmi": "支付寶提現",
            "shuxinmi": "還沒加銀行卡信息",
            "quemi": "未設定交易密碼",
            "shuquemi": "會員等級提現額度為",
            "dainyou": "當前等級提現需完成",
            "dianyoudi": "筆訂單",
            "shudainyou": "餘額不足",
            "fukuanshe": "會員等級今日提現次數不足",
            "bitedi": "開戶人名稱為必填項",
            "shugukuan": "開戶人名稱長度最大為30個字符",
            "jisheng": "銀行名稱為必填項",
            "qiangou": "銀行卡號為必填項",
            "xiacixiaoshi": "手機號碼為必填項",
            "yingjian": "銀行卡號已存在",
            "zonggong": "操作失敗",
            "maidian": "頁面不存在",
            "yingjiancheng": "獲得返傭",
            "zhuanzhang": "未登入用戶",
            "dianfeizong": "請不要重複提交",
            "zhuanzhangti": "獲取成功",
            "zhaunzhangfeiyong": "失敗",
            "zuidifei": "成功",
            "tikuanjin": "該姓名和銀行卡已綁定其他帳號",
            "zuidixian": "無法刪除預設收貨地址",
            "bijieshou": "登入密碼錯誤",
            "quezhi": "今日已簽到",
            "querenti": "簽到成功,獲得紅包",
            "yiwen": "簽到成功",
            "tili": "您的所有提現訂單",
            "yaohaoyou": "驗證透過",
            "yaohuoci": "請登陸後在搶單",
            "yihanwei": "搶單失敗,請稍後再試",
            "gongxihuo": "搶單失敗,商品庫存不足"
        },
        "taocan": {
            "title": "手機號碼已註冊",
            "text": "1分鐘內只能發送一封簡訊",
            "kuanggong": "發送成功",
            "liliang": "發送失敗",
            "jiage": "簡訊發送成功",
            "yingli": "參數不全"
        },
        "baoming": {
            "title": "伺服器空間不支援,請確認支援curl或fsocket ，聯絡您的空間商解決或更換空間",
            "text": "帳戶已過期"
        }
    },
    "login": {
        "yongdeng": "IP位址限制",
        "quedeng": "內容含有敏感詞",
        "yonghu": "商品參數異常",
        "mima": "可用餘額不足,請先充值",
        "xieyi": "今日金額",
        "tiaokaun": "今日用戶數",
        "tongyi": "今日線上人數",
        "wangmi": "年",
        "zhaomi": "月",
        "zhaomiti": "簽到",
        "feihuiyuan": "連續",
        "lizhi": "今天已簽到，獲得1個紅包",
        "chaunghu": "日",
        "yonghumming": "一",
        "mimafu": "二",
        "zhanghaoyou": "四",
        "jinggao": "五"
    },
    "botton": {
        "lianjie": {
            "0": "六",
            "1": "已簽到",
            "2": "今天已經簽到了",
            "3": "轉出"
        },
        "zhichi": {
            "0": "轉入",
            "1": "商城"
        }
    },
    "content": {
        "zhichu": "單",
        "jiage": "次",
        "yinliang": "無權限",
        "jiaoyizhe": "設定訊息",
        "btbjiage": "$",
        "queren": "100",
        "quxiao": "300",
        "shehe": {
            "0": "500",
            "1": "1000",
            "2": "3000"
        }
    },
    "buchong": {
        "caidan": "5000",
        "dengchu": "10000",
        "shangdian": "30000",
        "dan": "一個帳戶1天可搶",
        "choujiang": "一代佣金",
        "jiangli": "一級",
        "chongzhi": "三代佣金",
        "zhuanzhang": "三級",
        "yongjin": "上傳付款截圖",
        "lijikaishi": "上拉刷新",
        "mianfei": "下一等級專屬通道可獲得更高佣金",
        "kaishi": "下拉重新整理",
        "lianjie": "下級返傭",
        "zhoumo": "不能為空",
        "shizhi": "專屬客服",
        "jiaoyi": "兩次輸入的密碼不一致",
        "zhichi": "兩次輸入的資金密碼不一致",
        "fuzhi": "個人資訊",
        "dangqian": "為了杜絕平台監管，如匹配到訂單",
        "wanshan": "請確認交易密碼",
        "buyizhi": "買家留言",
        "ziyou": "了解",
        "mai": "二代佣金",
        "yaoqing": "二級",
        "yihan": "QR 圖碼",
        "gongxi": "交易密碼管理",
        "huifu": "交易明細"
    },
    "tanchuang": {
        "one": "今天已搶單數",
        "two": "今天已搶佣金",
        "title1": "今日戰果",
        "title2": "今日收益"
    },
    "weishangxian": {
        "weishangxian": "以上操作完成，可請聯絡客服上分",
        "yueshouru": "價格",
        "meiyuan": "任務增多",
        "qianggouzhong": "任務大廳",
        "chongzhidizhi": "任務返傭",
        "jine": "優惠券",
        "bufu": "會員永久有效",
        "zhengque": "會員等級",
        "xuanxiang": "會員詳情",
        "chongzhi": "餘額寶存取記錄",
        "xiaoshi": "餘額寶收益",
        "yongjiu": "餘額寶轉入",
        "yongjin": "餘額寶轉出",
        "renshu": "餘額寶",
        "hezuo": "餘額支付",
        "fenxiang": "餘額轉入",
        "chenggong": "餘額",
        "tuijianID": "你好,為了保證您的權益,請綁定正確的四大銀行(中行、建設、工商、農業)卡號與支行信息，如填寫錯誤導致無法到賬,本平台不負任何責任！本平台不支援四大行以外的其他銀行提現",
        "neirong": "佣金加成",
        "tuijian": "佣金比例"
    },
    "into_one": {
		"daizhifu": "充值訂單 待支付",
        "yibiaoban": "佣金",
        "nihao": "儲存二維碼到本地掃碼",
        "yue": "保存成功",
        "shebeigong": "儲存截圖,掃碼付款",
        "riqi": "資訊公告",
        "gaishu": "修改名稱",
        "kaicaizong": "修改密碼",
        "xiaoshili": "修改成功",
        "rili": "元",
        "zhouli": "充值中",
        "yeli": "充值中,請稍後再刷新餘額",
        "tuilian": "充值升級",
        "hezuo": "充值狀態",
        "fukuanxin": "升級解鎖",
        "tianjiadi": "充值解鎖",
        "gengxin": "充值訂單待支付",
        "yibiaoti": "充值記錄",
        "yaoqing": "充值說明",
        "yaoqingren": "充值請聯絡客服",
        "shijian": "充值金額",
        "choujiangci": "充值",
        "choujianggai": "充值.提現",
        "tuijianren": "免費註冊",
        "xiejie": "全力搶單中，搶單結果將在下方發放",
        "jiriqi": "全部商品",
        "dianjifu": "全部提現",
        "tishi": {
            "1": "全部",
            "2": "凍結中",
            "3": "分鐘之內沒有確定提交，系統將凍結該筆訂單金額"
        },
        "chongzhijin": "分",
        "chongzhigai": "刪除",
        "nindeyu": "到帳時間:5分鐘",
        "mianchong": "剩餘可用資產",
        "mianchongci": "載入中",
        "chongzhili": {
            "title": "升級成功",
            "jine": "去上傳",
            "shijian": "去搶單",
            "zhauntai": "去添加"
        },
        "yijiangli": "發送驗證碼",
        "yiqizhuan": "取消",
        "jianglili": "可提現餘額",
        "shezhi": "可用餘額",
        "mimashe": "各項條約",
        "dangqianmishu": "合作",
        "xinmi": "名稱",
        "shuxinmi": "後進入超時狀態",
        "quemi": "商品",
        "shuquemi": "商城首頁",
        "dainyou": "回到首頁",
        "dianyoudi": "團隊人數",
        "shudainyou": "團隊餘額",
        "fukuanshe": "團隊佣金狀況",
        "bitedi": "團隊總佣金",
        "shugukuan": "團隊總充值",
        "jisheng": "團隊總提現",
        "qiangou": "團隊搶單佣金",
        "xiacixiaoshi": "團隊報表",
        "yingjian": "團隊流水",
        "zonggong": "團隊管理",
        "maidian": "團隊",
        "yingjiancheng": "在瀏覽器中打開",
        "zhuanzhang": "線上支付",
        "dianfeizong": "地區",
        "zhuanzhangti": "複製成功",
        "zhaunzhangfeiyong": "複製連結",
        "zuidifei": "複製",
        "tikuanjin": "天",
        "zuidixian": "頭像設定",
        "bijieshou": "頭像",
        "quezhi": "如遇到問題需要協助請聯絡線上客服",
        "querenti": "姓名",
        "yiwen": "存一筆",
        "tili": "存入金額不符合系統要求",
        "yaohaoyou": "存入金額",
        "yaohuoci": "存取記錄",
        "yihanwei": "官方擔保",
        "gongxihuo": "官方提供"
    },
    "into_two": {
        "yibiaoban": "定期理財",
        "nihao": "定",
        "yue": "審核失敗",
        "shebeigong": "審核通過",
        "riqi": "客服中心",
        "gaishu": "客服",
        "kaicaizong": "網路",
        "xiaoshili": "密碼管理",
        "rili": "親愛的用戶，為了保障您的資金安全，請您綁定您的真實姓名和設定提款密碼。如果姓名與開戶名不一致，將無法提款",
        "zhouli": "小數點必須填寫",
        "yeli": "小時，到期後系統會自動解凍",
        "tuilian": "左右滑動查看更多",
        "hezuo": "已發送",
        "fukuanxin": "已完成",
        "tianjiadi": "已撤銷",
        "gengxin": "請輸入信箱",
        "yibiaoti": "已有帳號，去登入",
        "yaoqing": "已有帳號，馬上下載",
        "yaoqingren": "已過期",
        "shijian": "已通過",
        "choujiangci": "已駁回",
        "choujianggai": "開啟您的財富之路",
        "tuijianren": "開戶人",
        "xiejie": "開戶協議",
        "jiriqi": "開戶名",
        "dianjifu": "開戶地址",
        "tishi": {
            "1": "開戶行",
            "2": "開戶銀行",
            "3": "當日收益"
        },
        "chongzhijin": "待付款",
        "chongzhigai": "待處理",
        "nindeyu": "待審核",
        "mianchong": "待支付",
        "mianchongci": "待收貨",
        "chongzhili": {
            "title": "待解鎖",
            "jine": "微信端可直接長按辨識二維碼",
            "shijian": "忘記密碼",
            "zhauntai": "快速提現"
        },
        "yijiangli": "總充值",
        "yiqizhuan": "總提現",
        "jianglili": "總收益",
        "shezhi": "總資產",
        "mimashe": "您的餘額",
        "dangqianmishu": "您的訂單將於",
        "xinmi": "您的訂單已凍結,請耐心等候",
        "shuxinmi": "您的訂單已逾時,無法進行操作",
        "quemi": "您的身分資訊",
        "shuquemi": "您的銀行卡訊息",
        "dainyou": "您確定要刪除該地址嗎",
        "dianyoudi": "您尚未添加銀行卡信息",
        "shudainyou": "我已同意《服務協議》",
        "fukuanshe": "我已完成支付",
        "bitedi": "我已知曉並同意",
        "shugukuan": "我的餘額",
        "jisheng": "我的團隊",
        "qiangou": "我的總資產",
        "xiacixiaoshi": "我的手機號碼",
        "yingjian": "我的訂單",
        "zonggong": "我的錢包",
        "maidian": "我的金融卡",
        "yingjiancheng": "我的",
        "zhuanzhang": "螢幕截圖或直接",
        "dianfeizong": "所屬銀行",
        "zhuanzhangti": "所有商品",
        "zhaunzhangfeiyong": "所有類型",
        "zuidifei": "手機號碼有誤",
        "tikuanjin": "手機號碼輸入錯誤",
        "zuidixian": "手機號碼",
        "bijieshou": "手機號",
        "quezhi": "智慧型手機",
        "querenti": "手續費",
        "yiwen": "搶單中",
        "tili": "搶單時間",
        "yaohaoyou": "搶單編號",
        "yaohuoci": "搶單紀錄",
        "yihanwei": "記錄",
        "gongxihuo": "搶單說明"
    },
    "into_s1": {
        "yibiaoban": "搶單",
        "nihao": "接單數量",
        "yue": "接單返傭",
        "shebeigong": "推廣海報",
        "riqi": "推薦人數",
        "gaishu": "推薦商品",
        "kaicaizong": "推薦",
        "xiaoshili": "提交中",
        "rili": "提交成功,請耐心等待審核",
        "zhouli": "提交成功, 即將跳轉",
        "yeli": "提交訂單",
        "tuilian": "提交",
        "hezuo": "提現次數",
        "fukuanxin": "提現狀態",
        "tianjiadi": "提現申請已提交",
        "gengxin": "提現記錄",
        "yibiaoti": "提現費率",
        "yaoqing": "提現金額",
        "yaoqingren": "提現額度",
        "shijian": "提現",
        "choujiangci": "搜尋",
        "choujianggai": "支付方式",
        "tuijianren": "分行位址",
        "xiejie": "收件者",
        "jiriqi": "收款人",
        "dianjifu": "收益標準",
        "tishi": {
            "1": "收益類型",
            "2": "收益記錄",
            "3": "收貨人姓名"
        },
        "chongzhijin": "收貨地址資訊",
        "chongzhigai": "收貨地址修改",
        "nindeyu": "收貨地址編輯",
        "mianchong": "收貨地址",
        "mianchongci": "收貨身份資訊",
        "chongzhili": {
            "title": "新增人數",
            "jine": "新密碼",
            "shijian": "新手機號",
            "zhauntai": "時間"
        },
        "yijiangli": "昨日團隊佣金",
        "yiqizhuan": "昨日收益",
        "jianglili": "暫無數據",
        "shezhi": "暫無紀錄",
        "mimashe": "更多資訊",
        "dangqianmishu": "更多",
        "xinmi": "未綁定銀行卡,前往綁定",
        "shuxinmi": "未輸入地區，請設定",
        "quemi": "未輸入開戶行，請設定",
        "shuquemi": "未輸入支行地址，請設定",
        "dainyou": "未輸入電話號碼，請設定",
        "dianyoudi": "未輸入電話，請設定",
        "shudainyou": "未輸入真實姓名，請設定",
        "fukuanshe": "未輸入詳細地址，請設定",
        "bitedi": "未輸入銀行卡號，請設定",
        "shugukuan": "未輸入QQ，請設定",
        "jisheng": "本數據由",
        "qiangou": "本次提現扣除手續費",
        "xiacixiaoshi": "正在載入中",
        "yingjian": "每天可接單",
        "zonggong": "沒有二維碼,請點擊",
        "maidian": "沒有數據",
        "yingjiancheng": "沒有更多內容了",
        "zhuanzhang": "沒有更多的數據了",
        "dianfeizong": "沒有記錄哦",
        "zhuanzhangti": "註冊時間",
        "zhaunzhangfeiyong": "註冊",
        "zuidifei": "註：由於充值資訊量過大，充值前務必仔細核對帳戶卡號，本平台不定期更換帳號，有疑問請點線上客服",
        "tikuanjin": "活動中心",
        "zuidixian": "活躍人數",
        "bijieshou": "新增收貨地址",
        "quezhi": "溫馨提示",
        "querenti": "狀態",
        "yiwen": "使用者充值",
        "tili": "使用者名稱不能為空",
        "yaohaoyou": "使用者名稱輸入錯誤,要求2-12位字母或數字",
        "yaohuoci": "用戶接單",
        "yihanwei": "用戶提現",
        "gongxihuo": "電話號碼"
    },
    "into_f": {
        "yibiaoban": "登入密碼",
        "nihao": "登錄",
        "yue": "直屬",
        "shebeigong": "直屬",
        "riqi": "真實姓名",
        "gaishu": "確定修改",
        "kaicaizong": "確定綁卡",
        "xiaoshili": "確定",
        "rili": "確認充值",
        "zhouli": "確認取消嗎,取消將會導致金額凍結",
        "yeli": "確認密碼",
        "tuilian": "確認提取這一筆到餘額？未到期提取不計算利息！ ,並且扣除",
        "hezuo": "確認退出嗎",
        "fukuanxin": "秒後返回我的頁面",
        "tianjiadi": "秒",
        "gengxin": "立刻提現",
        "yibiaoti": "立刻購買",
        "yaoqing": "立即升級",
        "yaoqingren": "立即設定",
        "shijian": "等待買家確認收貨",
        "choujiangci": "等待買家確認",
        "choujianggai": "等待商家系統回應",
        "tuijianren": "篩選",
        "xiejie": "簡介",
        "jiriqi": "系統公告",
        "dianjifu": "系統基於LBS技術，透過雲端自動匹配商品",
        "tishi": {
            "1": "系統帳號",
            "2": "累計收益",
            "3": "線上充值"
        },
        "chongzhijin": "線下充值",
        "chongzhigai": "綁定手機號",
        "nindeyu": "綁定銀行卡",
        "mianchong": "統計",
        "mianchongci": "編輯收貨地址",
        "chongzhili": {
            "title": "編輯金融卡",
            "jine": "編輯",
            "shijian": "網路不太穩定,請您在訊號較好的地方再試",
            "zhauntai": "網路不穩定,請您在訊號較好的地方再試"
        },
        "yijiangli": "聯絡電話",
        "yiqizhuan": "去搶單",
        "jianglili": "自動",
        "shezhi": "自動計算",
        "mimashe": "自營商城",
        "dangqianmishu": "至",
        "xinmi": "取得驗證碼",
        "shuxinmi": "規則",
        "quemi": "解鎖",
        "shuquemi": "訂單編號",
        "dainyou": "訂單已凍結,解凍時間為",
        "dianyoudi": "訂單已超時",
        "shudainyou": "訂單總金額",
        "fukuanshe": "訂單總額",
        "bitedi": "訂單提交中",
        "shugukuan": "訂單提交成功",
        "jisheng": "訂單詳情",
        "qiangou": "訂單",
        "xiacixiaoshi": "記住密碼",
        "yingjian": "設為常用位址",
        "zonggong": "設為預設",
        "maidian": "設定頭像",
        "yingjiancheng": "詳情",
        "zhuanzhang": "詳細地址",
        "dianfeizong": "請上傳付款憑證",
        "zhuanzhangti": "請上傳充值憑證",
        "zhaunzhangfeiyong": "請仔細核對收款資訊",
        "zuidifei": "請付款",
        "tikuanjin": "請修改您的名稱",
        "zuidixian": "請務必轉帳金額保留小數點，以免影響充值時間",
        "bijieshou": "請向以下帳戶轉帳充值",
        "quezhi": "請諮詢線上客服完成充值後",
        "querenti": "請填寫充值姓名",
        "yiwen": "請填寫充值手機號",
        "tili": "請填寫充值金額",
        "yaohaoyou": "請填寫姓名",
        "yaohuoci": "請填寫手機號碼",
        "yihanwei": "請填寫正確的手機號碼",
        "gongxihuo": "請填寫詳細地址"
    },
    "into_s": {
        "yibiaoban": "請填寫詳細收貨地址",
        "nihao": "請牢記密碼,如忘記密碼,請聯絡客服",
        "yue": "請詢問線上客服(平台不定時更換帳戶)",
        "shebeigong": "請輸入交易密碼",
        "riqi": "請輸入充值金額",
        "gaishu": "請輸入原密碼",
        "kaicaizong": "請輸入密碼",
        "xiaoshili": "請輸入開戶人姓名",
        "rili": "請輸入開戶人手機號碼",
        "zhouli": "請輸入開戶行位址",
        "yeli": "請輸入開戶行",
        "tuilian": "請輸入開戶銀行",
        "hezuo": "請輸入您的新密碼",
        "fukuanxin": "請輸入手機號",
        "tianjiadi": "請輸入手機驗證碼",
        "gengxin": "請輸入推薦碼",
        "yibiaoti": "請輸入提現金額",
        "yaoqing": "請輸入收貨人姓名",
        "yaoqingren": "請輸入新密碼",
        "shijian": "請輸入手機號或者郵箱",
        "choujiangci": "請輸入用戶名",
        "choujianggai": "請輸入登入密碼",
        "tuijianren": "請輸入簡訊驗證碼",
        "xiejie": "請輸入帳號/密碼/验证码",
        "jiriqi": "請輸入資金密碼",
        "dianjifu": "請輸入轉入金額",
        "tishi": {
            "1": "請輸入邀請碼",
            "2": "請輸入銀行卡號",
            "3": "請輸入驗證碼"
        },
        "chongzhijin": "請選擇支付管道",
        "chongzhigai": "請選擇支付通道",
        "nindeyu": "請選擇收貨地址",
        "mianchong": "請選擇要升級的級別",
        "mianchongci": "帳戶餘額",
        "chongzhili": {
            "title": "帳戶凍結金額",
            "jine": "帳戶明細",
            "shijian": "帳戶金額",
            "zhauntai": "購買收益"
        },
        "yijiangli": "購買未輸入真實姓名，請設定",
        "yiqizhuan": "購買理財產品,惡意購買不計算收益,且收取手續費",
        "jianglili": "購買",
        "shezhi": "資金密碼",
        "mimashe": "跳轉中",
        "dangqianmishu": "轉帳請複製訊息，到網路銀行或支付寶完成轉帳充值",
        "xinmi": "輸入充值金額",
        "shuxinmi": "輸入名稱",
        "quemi": "輸入存入金額",
        "shuquemi": "輸入手機號",
        "dainyou": "輸入資金密碼",
        "dianyoudi": "返回中",
        "shudainyou": "返回",
        "fukuanshe": "尚未新增收穫地址",
        "bitedi": "尚未添加銀行卡",
        "shugukuan": "進店逛逛",
        "jisheng": "遠端主機正在分配",
        "qiangou": "退出登陸",
        "xiacixiaoshi": "選擇充值方式",
        "yingjian": "選擇提現方式",
        "zonggong": "選擇數量",
        "maidian": "選擇理財產品",
        "yingjiancheng": "邀請好友",
        "zhuanzhang": "加入以獲得更多利益",
        "dianfeizong": "邀請碼",
        "zhuanzhangti": "邀請連結:點擊複製",
        "zhaunzhangfeiyong": "請仔細核對收款資訊",
        "zuidifei": "金融卡提現",
        "tikuanjin": "金融卡帳戶",
        "zuidixian": "金融卡",
        "bijieshou": "銀行名稱",
        "quezhi": "問題",
        "querenti": "需協助，可聯絡客服人工充值",
        "yiwen": "需補交",
        "tili": "預計收益",
        "yaohaoyou": "預計返還",
        "yaohuoci": "首充人數",
        "yihanwei": "首頁",
        "gongxihuo": "馬上充值"
    },
    "into_se": {
        "yibiaoban": "驗證碼",
        "nihao": "預設",
        "yue": "APP請手動截圖，儲存到本地掃碼",
        "shebeigong": "APP請手動",
        "riqi": "Home",
        "gaishu": "PasswordLogin",
        "kaicaizong": "暫不提交",
        "xiaoshili": "註冊成功",
        "rili": "可以升級",
        "zhouli": "無法升級",
        "yeli": "未達升級條件,無法升級",
        "tuilian": "你已達到升級標準,已完成升級",
        "hezuo": "系統通知",
        "fukuanxin": "用戶餘額不足",
        "tianjiadi": "邀請用戶不足",
        "gengxin": "升級條件不滿足",
        "yibiaoti": "需要帳戶餘額大於",
        "yaoqing": "邀請",
        "yaoqingren": "才可以解鎖",
        "shijian": "錢包地址",
        "choujiangci": "可用錢包掃描轉賬",
        "choujianggai": "今日團隊佣金",
        "tuijianren": "APP下載",
        "xiejie": "充值彩金",
        "jiriqi": "請輸入TRC20位址",
        "dianjifu": "請輸入ERC20位址",
        "tishi": {
            "1": "關於我們",
            "2": "代理商",
            "3": "規則"
        },
        "chongzhijin": "介紹",
        "chongzhigai": "資質",
        "nindeyu": "打開禮品盒時的驚喜",
        "mianchong": "立即賺錢",
        "mianchongci": "舊密碼",
        "chongzhili": {
            "title": "請輸入舊密碼",
            "jine": "請再次輸入密碼",
            "shijian": "修改密碼成功",
            "zhauntai": "修改密碼失敗"
        },
        "yijiangli": "請勾選同意協議",
        "yiqizhuan": "您已達到升級標準，已自動升級",
        "jianglili": "由於餘額變動已降級",
        "shezhi": "系統通知",
        "mimashe": "交易訂單",
        "dangqianmishu": "已被系統強制付款，如有疑問請聯絡客服",
        "xinmi": "開啟自動搶單",
        "shuxinmi": "關閉自動搶單",
        "quemi": "使用者名稱重複",
        "shuquemi": "由於餘額變動已降級",
        "dainyou": "您已達到升級標準，已自動升級",
        "dianyoudi": "電話",
        "shudainyou": "關於我們",
        "fukuanshe": "立即查看",
        "bitedi": "平台",
        "shugukuan": "公告",
        "jisheng": "請好友賺現金",
        "chongxindenglu": "請重新登入",
        "pingtaijianjie": "平台簡介",
        "pingtaijianjie1": "搶單規則",
        "pingtaijianjie2": "代理合作",
        "pingtaijianjie3": "公司資質"
    },
    "qing_sd": "請稍等",
    "loading1": "連線代理",
    "loading2": "請求訂單",
    "loading3": "搶單中",
	goods:['绿色玻璃杯','尊享护肤品','食品级塑料杯','古典香水','进口咖啡豆','迪士尼同款小熊'], 
	tab_name:['首頁','訂單記錄','下單','客服','我的'],
	pingjia:'評價',
	login_t1:'一站式全球購物賺取回饋',
	zhangh:'請輸入手機號',
	email:'Email',
	use_app:'Use App',
	index_t1:'Extra 30% Off + 10% Cashback + Free Shipping  on Your First App Purchase. T&Cs Apply',
	qianbao:'錢包',
	huoqu_yj:"獲取佣金",
	zhangh_ye:'賬戶餘額',
	zhangh_je:'賬戶金額',
	huoq_yj:'獲取佣金',
	dingd_s:'訂單數量',
	caoz_bz:'操作步驟',
	caoz_t1:'1、点击开始任务按钮根据提示完成任务',
	caoz_t2:'2、完成任务以后就可以结算佣金到余额',
	kefu_t1:'如果您有什么问题或者需要帮助，',
	kefu_t2:'请联系在线客服为您解决',
	kefu_t3:'您的專屬客服',
	changj_wtjd:'常见问题解答',
	changj_wt:[
		{name:'如何充值，有哪些支付方式?',value:' 本系统对多个国家开放，我们提供国际化的支付方式有:USDT(ERC20)。同时我们还针对不同国家支持本国的货币。'},
		{name:'我如何才能投资并获得收益?',value:'您可以在系统中参与商品交易，每天获得稳定的交易收入。所有收入均可提取至您的银行卡。'},
		{name:'如何注册会员?',value:'采用邀请制注册新会员，为了保证已注册会员的收益，防止过度注册降低收益，新会员只能在现有会员邀请下注册。'},
		{name:'购买金额是否有限制?',value:'有，为了让更多会员有机会获得收益，系统每一个账号都有一个购买金额的最低限制。'}
	],
	yonghu_m:'用戶名',
	shoukuan_zh:'收款賬戶',
	youxiang:'郵箱',
	zhanghao:'賬號',
	xiugai_mima:'修改密碼',
	xuanze_yy:'選擇語言',
	queren:'確認',
	bangka:'請綁定收款賬戶',
	xingy_d:'恭喜，您搶到了幸運訂單',
	"nextrecharge": {
	    "a": "請向以下賬戶轉賬充值",
	    "b": "到賬時間：5分鐘",
	    "c": "所屬銀行",
	    "d": "銀行卡號",
		"e": "钱包地址",
		"f": "銀行卡號",
		"g": "銀行卡號",
		"h": "銀行卡號",
		"i": "銀行卡號",
		"j": "銀行卡號",
		"k": "銀行卡號",
		"l": "銀行卡號",
		"m": "銀行卡號",
		"n": "請務必轉賬金額保留小數點,以免影響充值時間",
		"o": "溫馨提示",
		"p": "1.轉賬請複制信息,到網上銀行或支付寶完成轉賬充值。",
		"q": "2.APP請手動截屏或直接保存二維碼到本地掃碼。",
		"r": "3.微信端可直接長按識別二維碼。",
		"s": "4.以上操作完成,可請聯繫客服上分。",
	},
}	